module.exports = __webpack_public_path__ + "static/media/dinner_icon.116c0b7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dinner_icon.svg
// module id = 55
// module chunks = 0